var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-minus-ps';
                    var viewUrl = 'gfx/sprite.svg#view-icon-minus-ps';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 30 30',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };